import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'bizflex-error-page-bad-request',
  standalone: true,
  imports: [],
  templateUrl: './bad-request.component.html',
  styleUrls: ['./bad-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadRequestComponent {
  @HostBinding('class') private readonly hostClass = 'text-center !mt-0';
}
